import { render } from "./mot-history.vue?vue&type=template&id=28d16202&ts=true"
import script from "./mot-history.vue?vue&type=script&lang=ts"
export * from "./mot-history.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__